import { HtmlGraphicObject } from "../html/html-graphic-object.js";
import { createSvgAndSvgObjects } from "../utils/create-svg.js";
import { NamedObjectContainer, SingleNamedObject } from "../named-object-container";

export class SvgRectangleArea extends HtmlGraphicObject {
  constructor(settings) {
    super(settings);
    HtmlGraphicObject.setHtmlObject(
      this.settings,
      createSvgAndSvgObjects(
        "svg",
        ["x", `${this.settings.htmlObject.locationInPixels.x}px`],
        ["y", `${this.settings.htmlObject.locationInPixels.y}px`],
        ["min-width", `${this.settings.htmlObject.sizeInPixels.width}px`],
        ["width", `${this.settings.htmlObject.sizeInPixels.width}px`],
        ["height", `${this.settings.htmlObject.sizeInPixels.height}px`],
        ["style", `margin: 0px; position: absolute;`]
      )
    );

    this.backgroundRectangle = createSvgAndSvgObjects(
      "rect",
      ["x", `0px`],
      ["y", `0px`],
      ["width", `${this.settings.sizeInPixels.width}`],
      ["height", `${this.settings.sizeInPixels.height}`],
      ["fill", "transparent"],
      ["stroke", "transparent"],
      ["style", `margin: 0px; position: absolute;`]
    );
    this.settings.htmlObject.ref.appendChild(this.backgroundRectangle);

    this.childItemsContainer = new NamedObjectContainer("Items");
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    if (debugSettings.fillHtmlElements) {
      this.setBackgroundFillColor(this.settings.debug.boxFillColor);
    }
    this.childItemsContainer.forEach(item => item.setDebugMode(debugSettings));
  }

  addOnClickedFunction(action) {
    this.addEventListener("click", action);
  }

  addItem(name, htmlGraphicChildObject) {
    this.childItemsContainer.add(new SingleNamedObject(name, htmlGraphicChildObject));
  }

  setBackgroundFillColor(color) {
    this.backgroundRectangle.setAttribute("fill", color);
  }

  setBackgroundStrokeColor(color) {
    this.backgroundRectangle.setAttribute("stroke", color);
  }

  createBorders() {
    super.createBorders();
    this.childItemsContainer.forEach(item => {
      item.setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
      item.createBorders();
    });
  }

  createHtmlBorders() {
    super.createHtmlBorders();
    this.backgroundRectangle.setAttribute("width", `${this.settings.sizeInPixels.width}px`);
    this.backgroundRectangle.setAttribute("height", `${this.settings.sizeInPixels.height}px`);
    this.settings.htmlObject.ref.setAttribute("x", `${this.settings.htmlObject.absoluteLocation.x}px`);
    this.settings.htmlObject.ref.setAttribute("y", `${this.settings.htmlObject.absoluteLocation.y}px`);
    this.settings.htmlObject.ref.setAttribute("width", `${this.settings.htmlObject.sizeInPixels.width}px`);
    this.settings.htmlObject.ref.setAttribute("height", `${this.settings.htmlObject.sizeInPixels.height}px`);
  }
}
